/* eslint-disable react/jsx-pascal-case */
import {
  Badge,
  Button,
  Offcanvas,
  OverlayTrigger,
  Tooltip,
} from "react-bootstrap";
import { useEffect, useState } from "react";
import * as Icon from "react-bootstrap-icons";
import {
  handleClose,
  handleShow,
  handleToggleNavbar,
  setSidebarWidth,
} from "../../store/reducers/reducer-sidebar";
import { useDispatch, useSelector } from "react-redux";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import Form from "react-bootstrap/Form";
import img_sidebar_toggle from "../../assets/images/sidebar-toggle.png";
import slsLogo from "../../assets/images/loanlinq.png";
import slsLogoMini from "../../assets/images/logo-mini.png";

// import Icon from '@mdi/react';
import DashboardIcon from "mdi-react/ViewDashboardOutlineIcon";
import SubmitALoanIcon from "mdi-react/PlusCircleOutlineIcon";

import ReportsAndDocumentsIcon from "mdi-react/FileDocumentOutlineIcon";
import DefaultManagementIcon from "mdi-react/CogOutlineIcon";
import AccountCogOutlineIcon from "mdi-react/AccountCogOutlineIcon";
import AccountOutlineIcon from "mdi-react/AccountOutlineIcon";
// import ToolsIcon from "mdi-react/ToolsIcon";
// import FormOutlineIcon from "mdi-react/FormOutlineIcon";
import HelpIcon from "mdi-react/HelpIcon";
import { navListConverter } from "../../Utils";
import SupportIcon from "mdi-react/SupportIcon";
import HomeLockIcon from "mdi-react/HomeLockIcon";
import { handleTermsPopup } from "../../store/reducers/dashboardSlice";
import { roleType } from "../../Utils/constant";
import SearchLoan from "../SearchLoan/SearchLoan";
import { BsFillCalendar2CheckFill } from "react-icons/bs";
const hideSidebarWidthAdjustment = false;

function Sidebar({ logout, name, ...props }) {
  const [showLoanSearch, setShowLoanSearch] = useState(false);
  const [expandedMenu, setExpandedMenu] = useState(null);
  const [manualOverrides, setManualOverrides] = useState({});
  const selectedDatabase = useSelector(
    (state) => state.account.selectedAccount.databasename,
  );
  const selectedRole = useSelector((state) => state.account.selectedRole.value);
  const selectedRoleName = useSelector(
    (state) => state.account.selectedRole.label,
  );
  const badgeCount = null;
  const pendingAuthPayoffCount = useSelector(
    (state) => state.dashboard.pendingAuthPayoffCount,
  );
  const pendingLenderApproval = useSelector(
    (state) => state.dashboard.pendingLenderApproval,
  );

  const routeState = navListConverter(
    selectedRole,
    useSelector((state) => state.RS_Authentication.route),
    selectedRoleName,
    selectedDatabase,
    badgeCount,
    pendingAuthPayoffCount,
    pendingLenderApproval,
  );
  const masqueradeEmail = useSelector(
    (state) => state.RS_Authentication.masquerade,
  );
  const [disableSidebarWidthAdjustmentFeature] = useState(true);
  const [activeBar, setActiveBar] = useState("");
  const show = useSelector((state) => state.RS_Sidebar.show);
  const { sidebarWidth, isLargeDevice } = useSelector(
    (state) => state.RS_Sidebar,
  );
  const dispatch = useDispatch();
  const handleSidebarToogle = () => {
    show ? dispatch(handleClose()) : dispatch(handleShow());
  };
  const offcanvasMinimumWidth = useSelector(
    (state) => state.RS_Sidebar.sidebarMinimumWidth,
  );
  const { languageDetected } = useSelector((state) => state.dashboard);

  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (activeBar.to !== "/docs") {
      // if (!isLargeDevice) {
      //   dispatch(setSidebarWidth("100px"));
      // } else if (isLargeDevice) {
      //   dispatch(setSidebarWidth("260px"));
      // }
      dispatch(setSidebarWidth("260px"));
      dispatch(handleToggleNavbar(false));
    } else {
      dispatch(setSidebarWidth("260px"));
      dispatch(handleToggleNavbar(true));
    }
  }, [activeBar, isLargeDevice]);

  // useEffect(() => {
  //   if (activeBar.to === "/borrower-dashboard-two") {
  //     dispatch(setSidebarWidth("100px"));
  //   }
  // }, [activeBar]);

  const filteredRouteState = routeState
    .filter((item) => item.to !== "/support" || !masqueradeEmail.isIt)
    .map((item) => {
      if (item.target === "forms" && selectedRole === "L") {
        return {
          ...item,
          to: "/lender/forms",
        };
      } else if (item.target === "forms" && selectedRole === "V") {
        return {
          ...item,
          to: "/broker/forms",
        };
      } else if (item.target === "forms" && selectedRole === "B") {
        return {
          ...item,
          to: "/borrower/forms",
        };
      }
      return item;
    });

  const toggleSubmenu = (item) => {
    const currentlyExpanded =
      manualOverrides[item.name] !== undefined
        ? manualOverrides[item.name]
        : item.children?.some((child) =>
            location.pathname.startsWith(child.to),
          );

    setManualOverrides((prev) => ({
      ...prev,
      [item.name]: !currentlyExpanded,
    }));
  };

  // const finalRouteState = filteredRouteState.filter(
  //   (item) => item.to !== "/docs" || selectedRole !== "V"
  // );
  const finalRouteState = filteredRouteState;

  return (
    <>
      <Button
        variant=""
        onClick={handleSidebarToogle}
        className="me-2 d-flex align-items-center"
      >
        <Icon.List className="me-2" /> {name}
      </Button>
      <Offcanvas
        scroll={true}
        show={show}
        backdrop={false}
        className=""
        style={{
          marginTop: "calc(0px + 0px)",
          width: sidebarWidth,
          // top: masqueradeEmail.isIt ? "30px" : "0px",
          top: masqueradeEmail.isIt
            ? `calc(30px + ${languageDetected ? "40px" : "0px"})`
            : languageDetected
              ? "40px"
              : "",
        }}
        onHide={() => {
          dispatch(handleClose());
        }}
        {...props}
      >
        <Offcanvas.Header className="position-relative" closeButton={false}>
          {/* <Offcanvas.Title>SLS Portal Menu</Offcanvas.Title> */}
          {sidebarWidth.replace("px", "") > 150 ? (
            <div className="container-fluid">
              <div
                className={
                  sidebarWidth.replace("px", "") < 250
                    ? "d-flex flex-column"
                    : "d-flex"
                }
              >
                <div className="me-2" style={{ position: "relative" }}>
                  <div className=""></div>
                </div>
                <div className="">
                  <img
                    src={slsLogo}
                    style={{
                      width: "75%",
                      marginBottom: "20px",
                      marginTop: "20px",
                    }}
                    alt="logo"
                  />
                </div>
              </div>
            </div>
          ) : (
            <div className="container-fluid">
              <div
                className={
                  sidebarWidth.replace("px", "") < 250
                    ? "d-flex flex-column"
                    : "d-flex"
                }
              >
                <div className="me-2" style={{ position: "relative" }}>
                  <div className=""></div>
                </div>
                <div className="">
                  <img
                    src={slsLogoMini}
                    style={{
                      width: "75%",
                      marginBottom: "20px",
                      marginTop: "20px",
                    }}
                    alt="logo"
                  />
                </div>
              </div>
            </div>
          )}
          <Button
            variant="transparent"
            style={{
              position: "absolute",
              top: "13px",
              right: "-28px",
              // background: 'transparent',
              border: "transparent",
              outline: "unset",
              padding: "5px 7px 5px 0px",
              borderRadius: "0 20px 20px 0",
              // marginBottom:'30px'
            }}
            onClick={() => {
              sidebarWidth.replace("px", "") < 101
                ? dispatch(setSidebarWidth("260px"))
                : dispatch(setSidebarWidth("100px"));
            }}
          >
            {sidebarWidth.replace("px", "") < 101 ? (
              <img
                src={img_sidebar_toggle}
                className=""
                style={{ height: "20px", width: "20px", borderRight: "" }}
                alt=""
              />
            ) : (
              <img
                src={img_sidebar_toggle}
                className=""
                style={{ height: "20px", width: "20px", borderRight: "" }}
                alt=""
              />
            )}
          </Button>
        </Offcanvas.Header>
        <Offcanvas.Body className="pt-0">
          {!hideSidebarWidthAdjustment &&
            !disableSidebarWidthAdjustmentFeature && (
              <div className="mt-0 mb-4">
                <Form.Label></Form.Label>
                <Form.Range
                  onChange={(e) => {
                    let newValue =
                      (offcanvasMinimumWidth + parseInt(e.target.value)) * 2;
                    if (newValue < 80) {
                      newValue = offcanvasMinimumWidth;
                    }
                    let stringValue = newValue.toString() + "px";
                    dispatch(setSidebarWidth(stringValue));
                  }}
                  value={
                    parseInt(sidebarWidth.replace("px", "")) / 2 -
                    offcanvasMinimumWidth
                  }
                />
              </div>
            )}
          <div className="d-flex flex-column align-items-between justify-content-between h-100 container-fluid">
            <div id="navigation-links" className="">
              {finalRouteState?.map((item, index) => {
                const hasChildren =
                  item.children?.length > 0 &&
                  item?.childrenVisibility?.includes(selectedRole);
                const isChildActive = item.children?.some((child) =>
                  location.pathname.startsWith(child.to),
                );

                const isExpanded =
                  manualOverrides[item.name] !== undefined
                    ? manualOverrides[item.name]
                    : isChildActive;

                return (
                  <div
                    // className={item.to !== "/docs" ? item.target : "doc"}
                    className={
                      item.to === "/docs"
                        ? "doc"
                        : item.to === "/borrower-dashboard-two"
                          ? "borrowerDashboard"
                          : item.target
                    }
                    key={index}
                  >
                    {parseInt(sidebarWidth.replace("px", "")) < 256 ? (
                      <OverlayTrigger
                        key={index}
                        placement={"right"}
                        overlay={
                          <Tooltip id={`tooltip-${index}`}>
                            {item.to === "/docs"
                              ? "Help Resources"
                              : item.to === "/borrower-dashboard-two"
                                ? "Dashboard"
                                : item.name}
                          </Tooltip>
                        }
                      >
                        <div>
                          <NavLink
                            className={({ isActive }) => {
                              if (isActive && activeBar.to !== item.to) {
                                item.active = true;
                                setActiveBar(item);
                              } else {
                                item.active = false;
                              }

                              return isActive
                                ? "active text-decoration-none d-flex align-items-center justify-content-center text-primary position-relative"
                                : "inactive text-decoration-none d-flex align-items-center justify-content-center text-primary position-relative inactiveHover";
                            }}
                            to={item.to}
                          >
                            {sidebarWidth.replace("px", "") > 150 ? (
                              <Button
                                key={index}
                                className="kd-sidebar-button w-100 mb-4 py-5 px-3 d-flex justify-content-start align-items-center"
                                variant={"light"}
                              >
                                <span>{item.icon()}</span>{" "}
                                <span
                                  className="d-inline-block"
                                  style={{
                                    width: sidebarWidth.replace("px", "") - 100,
                                    textOverflow: "ellipsis",
                                    overflow: "hidden",
                                    whiteSpace: "nowrap",
                                    textAlign: "start",
                                  }}
                                >
                                  {item.to === "/docs"
                                    ? "Help Resources"
                                    : item.name === "Help"
                                      ? "Contact Us"
                                      : item.to === "/borrower-dashboard-two"
                                        ? "Dashboard"
                                        : item.name}
                                </span>
                              </Button>
                            ) : (
                              <Button
                                key={index}
                                className="kd-sidebar-button-2 py-5 px-0 w-100 mb-4 d-flex justify-content-center align-items-top"
                                variant={item.active ? "primary" : "light"}
                              >
                                <span>{item.icon()}</span>
                              </Button>
                            )}
                          </NavLink>
                        </div>
                      </OverlayTrigger>
                    ) : (
                      <div key={index} className="sidebar-menu-item">
                        {hasChildren ? (
                          <>
                            <Button
                              className={`w-100 mb-2 py-5 px-3 d-flex justify-content-start align-items-center position-relative ${
                                isChildActive
                                  ? "active kd-sidebar-button"
                                  : "inactiveHover"
                              }`}
                              variant={isChildActive ? "primary" : "light"}
                              onClick={() => toggleSubmenu(item)}
                            >
                              <span>{item.icon()}</span>

                              {sidebarWidth.replace("px", "") > 150 && (
                                <>
                                  <span
                                    className="d-inline-block ms-2 flex-grow-1"
                                    style={{
                                      textOverflow: "ellipsis",
                                      overflow: "hidden",
                                      whiteSpace: "nowrap",
                                      textAlign: "start",
                                    }}
                                  >
                                    {item.name}
                                  </span>

                                  {/* {pendingAuthPayoffCount > 0 && (
                                        <span className="sidebar-notification-badge ms-2 rounded-pill flashing-badge p-0">
                                          {pendingAuthPayoffCount > 99
                                            ? "99+"
                                            : pendingAuthPayoffCount}
                                        </span>
                                      )} */}

                                  <span className="ms-auto">
                                    {isExpanded ? (
                                      <Icon.ChevronDown />
                                    ) : (
                                      <Icon.ChevronRight />
                                    )}
                                  </span>
                                </>
                              )}
                            </Button>

                            {isExpanded &&
                              sidebarWidth.replace("px", "") > 150 && (
                                <div className="sidebar-submenu">
                                  {item.children.map((child, childIndex) => (
                                    <NavLink
                                      key={childIndex}
                                      to={child.to}
                                      // className={({ isActive }) =>
                                      //   `sidebar-submenu-link text-decoration-none ${
                                      //     isActive ? "active" : ""
                                      //   }`
                                      // }
                                      className={({ isActive }) => {
                                        if (
                                          isActive &&
                                          activeBar.to !== item.to
                                        ) {
                                          item.active = true;
                                          setActiveBar(item);
                                        } else {
                                          item.active = false;
                                        }

                                        return isActive
                                          ? "sidebar-submenu-link text-decoration-none active"
                                          : "sidebar-submenu-link text-decoration-none inactiveHover";
                                      }}
                                    >
                                      <span>{child.name}</span>
                                      {child.notificationCount > 0 && (
                                        <span className="sidebar-notification-badge ms-2 rounded-pill flashing-badge">
                                          {child.notificationCount > 99
                                            ? "99+"
                                            : child.notificationCount}
                                        </span>
                                      )}
                                    </NavLink>
                                  ))}
                                </div>
                              )}
                          </>
                        ) : (
                          <NavLink
                            className={({ isActive }) => {
                              if (isActive && activeBar.to !== item.to) {
                                item.active = true;
                                setActiveBar(item);
                              } else {
                                item.active = false;
                              }

                              return isActive
                                ? "active text-decoration-none d-flex align-items-center justify-content-center text-primary position-relative"
                                : "inactive text-decoration-none d-flex align-items-center justify-content-center text-primary position-relative inactiveHover";
                            }}
                            to={item.to}
                          >
                            {sidebarWidth.replace("px", "") > 150 ? (
                              <Button
                                key={index}
                                className="kd-sidebar-button w-100 mb-4 py-5 px-3 d-flex justify-content-start align-items-center"
                                variant={"light"}
                              >
                                <span>{item.icon()}</span>{" "}
                                <span
                                  className="d-inline-block"
                                  style={{
                                    width: sidebarWidth.replace("px", "") - 100,
                                    textOverflow: "ellipsis",
                                    overflow: "hidden",
                                    whiteSpace: "nowrap",
                                    textAlign: "start",
                                  }}
                                >
                                  {item.to === "/docs"
                                    ? "Help Resources"
                                    : item.name === "Help"
                                      ? "Contact Us"
                                      : item.to === "/borrower-dashboard-two"
                                        ? "Dashboard"
                                        : item.name}
                                </span>
                              </Button>
                            ) : (
                              <Button
                                key={index}
                                className="kd-sidebar-button-2 py-5 px-0 w-100 mb-4 d-flex justify-content-center align-items-top"
                                variant={item.active ? "primary" : "light"}
                              >
                                <span>{item.icon()}</span>
                              </Button>
                            )}
                          </NavLink>
                        )}
                      </div>
                    )}
                  </div>
                );
              })}
              {selectedRole !== roleType.borrower && (
                <div>
                  <div
                    className={
                      "inactive text-decoration-none d-flex align-items-center justify-content-center text-primary"
                    }
                    // to={item.to}
                  >
                    {sidebarWidth.replace("px", "") > 150 ? (
                      <Button
                        className="kd-sidebar-button w-100 py-5 px-3 d-flex justify-content-start align-items-center d-flex gap-3 inactiveHover"
                        variant={"light"}
                        onClick={() => setShowLoanSearch(true)}
                      >
                        <span>{<Icon.Search />}</span>{" "}
                        <span
                          className="d-inline-block"
                          style={{
                            width: sidebarWidth.replace("px", "") - 100,
                            textOverflow: "ellipsis",
                            overflow: "hidden",
                            whiteSpace: "nowrap",
                            textAlign: "start",
                          }}
                        >
                          Loan Search
                        </span>
                      </Button>
                    ) : (
                      <Button
                        // key={index}
                        className="kd-sidebar-button-2 py-5 px-0 w-100 mb-4 d-flex justify-content-center align-items-top"
                        // variant={item.active ? "primary" : "light"}
                      >
                        {/* <span>{item.icon()}</span>1 */}
                      </Button>
                    )}
                  </div>
                </div>
              )}
            </div>
            <SearchLoan
              show={showLoanSearch}
              onHide={() => setShowLoanSearch(false)}
            />
            <div id="bottom-links">
              <div className="d-flex align-items-center"></div>
              <br />
              {sidebarWidth.replace("px", "") > 150 && (
                <div
                  className="d-flex justify-content-between"
                  style={{ fontSize: "12px" }}
                >
                  <a
                    href="https://superiorloanservicing.com/privacy-policy"
                    target="_blank"
                    rel="noreferrer"
                  >
                    Privacy Policy
                  </a>
                  <a
                    href="https://superiorloanservicing.com/terms-of-service"
                    target="_blank"
                    rel="noreferrer"
                  >
                    Terms of Use
                  </a>
                </div>
              )}
              {sidebarWidth.replace("px", "") > 150 &&
                // location.pathname != "/walkthrough" && (
                location.pathname !== "/login" && (
                  // selectedRole !== "B" &&
                  <div>
                    <button
                      className="btn btn-primary w-100 text-white btn-outline p-0"
                      onClick={() => {
                        navigate("walkthrough");
                        dispatch(handleTermsPopup(false));
                      }}
                    >
                      Guided Tour
                    </button>
                  </div>
                )}
            </div>
          </div>
        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
}

export default function SidebarComp({ logout }) {
  return <Sidebar logout={logout} placement="start" name="Menu" />;
}
export const allNavbarList = (badgeCount, pendingAuthPayoffCount, pendingLenderApproval, role) => [
  {
    target: "dashboard",
    name: "Dashboard",
    to: "/dashboard",
    active: true,
    icon: () => {
      return <DashboardIcon className="me-3" />;
    },
  },
  {
    target: "allLoans",
    name: "All Loans",
    to: "/allLoans",
    active: false,
    icon: () => {
      return <DashboardIcon className="me-3" />;
    },
  },
  {
    target: "userManagment",
    name: "User Managment",
    to: "/userManagment",
    active: true,
    icon: () => {
      return <DashboardIcon className="me-3" />;
    },
  },

  {
    target: "loanDetails",
    name: "Loan Details",
    to: "/borrower-dashboard-two",
    active: false,
    icon: () => {
      return <DashboardIcon className="me-3" />;
    },
  },

  {
    target: "loanDetails",
    name: "Loan Details",
    to: "/loans",
    active: false,
    icon: () => {
      return <ReportsAndDocumentsIcon className="me-3" />;
    },
  },
  // {
  //   target: "submit-loan",
  //   name: "Submit a Loan",
  //   to: "/submit-a-loan",
  //   active: false,
  //   icon: () => {
  //     return <SubmitALoanIcon className="me-3" />;
  //   },
  // },
  {
    target: "rnd",
    name: "Reports & Document",
    to: "/reports-and-documents",
    active: false,
    icon: () => {
      return <ReportsAndDocumentsIcon className="me-3" />;
    },
  },
  {
    target: "reportAndDocumentBorrower",
    name: "Reports & Documents",
    to: "/reports-documents-borrower",
    active: false,
    icon: () => {
      return <ReportsAndDocumentsIcon className="me-3" />;
    },
  },

  {
    target: "defaults",
    name: "Default Management",
    to: "/default-management",
    active: false,
    icon: () => {
      return <HomeLockIcon className="me-3" />;
    },
  },
  {
    target: "demands",
    name: "Payoff Demands",
    to: role === "L" ? "/demand-payoff" : "/demand-payoff-auth",
    active: false,
    icon: () => {
      return (
        <span style={{ display: "inline-block" }}>
          <Icon.Receipt className="me-3" size={20} />
          {((pendingAuthPayoffCount > 0 && role === "B") ||
            (pendingLenderApproval > 0 && role === "L")) && (
            <Badge
              bg="error"
              className="position-absolute translate-middle badge rounded-pill bg-error border border-light flashing-badge d-flex align-items-center justify-content-center"
              pill
              style={{
                height: "30px",
                width: "30px",
                top: role === "L" ? "45%" : "50%",
                right: "10%",
              }}
            >
              {role === "B" ? pendingAuthPayoffCount : pendingLenderApproval}
            </Badge>
          )}
        </span>
      );
    },
    children: [
      {
        name: "Payoff Requests",
        to: "/demand-payoff-auth",
      },
      {
        name: "Pending Authorization",
        to: "/payoff-auth-requests",
        notificationCount: pendingAuthPayoffCount,
      },
    ],
    childrenVisibility: ["B"],
  },
  {
    target: "account",
    name: "Account",
    to: "/account",
    active: false,
    icon: () => {
      return <AccountOutlineIcon className="me-3" />;
    },
  },
  {
    target: "support",
    name: "Support",
    to: "/support",
    active: false,
    icon: () => {
      return <SupportIcon className="me-3" />;
    },
  },
  {
    target: "dossdoc",
    name: "DossDoc",
    to: "/dossdoc",
    active: false,
    icon: () => {
      return <DefaultManagementIcon className="me-3" />;
    },
  },
  {
    target: "support",
    name: "Support",
    to: "/docs",
    active: false,
    icon: () => {
      return <DefaultManagementIcon className="me-3" />;
    },
  },
  {
    target: "maturity",
    name: "Menu Items Handler",
    to: "/menu-items-handler",
    active: false,
    icon: () => {
      return <DefaultManagementIcon className="me-3" />;
    },
  },
  {
    target: "maturity",
    name: "Admin Report List",
    to: "/admin-report-list",
    active: false,
    icon: () => {
      return <DefaultManagementIcon className="me-3" />;
    },
  },

  // {
  //   target: "maturity",
  //   name: "Maturity Override Tool",
  //   to: "/maturityOverrideTool",
  //   active: false,
  //   icon: () => {
  //     return <DefaultManagementIcon className="me-3" />;
  //   },
  // },
  // {
  //   target: "secure",
  //   name: "Secure Document Upload",
  //   to: "/tools/secureDocumentUpload",
  //   active: false,
  //   icon: () => {
  //     return <DefaultManagementIcon className="me-3" />;
  //   },
  // },
  // /tools/maturityOverrideTool
  // {
  //   target: "tools",
  //   name: "Tools",
  //   to: "/tools",
  //   active: false,
  //   icon: () => {
  //     return <ToolsIcon className="me-3" />;
  //   },
  // },
  // {
  //   target: "forms",
  //   name: "Forms",
  //   to: "/forms",
  //   active: false,
  //   icon: () => {
  //     return <FormOutlineIcon className="me-3" />;
  //   },
  // },
  {
    target: "help",
    name: "Help",
    to: "/help",
    active: false,
    icon: () => {
      return <HelpIcon className="me-3" />;
    },
  },
  {
    target: "adminSettings",
    name: "Admin Settings",
    to: "/admin-settings",
    active: false,
    icon: () => {
      return <AccountCogOutlineIcon className="me-3" />;
    },
  },
  {
    target: "tickets",
    name: "Tickets",
    to: "/tickets",
    active: false,
    icon: () => {
      return <SubmitALoanIcon className="me-3" />;
    },
  },
  {
    target: "dossdocs",
    name: "DossDocs",
    to: "/dossdoc-promo",
    active: false,
    className: "",
    icon: () => {
      return (
        <span style={{ position: "relative", display: "inline-block" }}>
          <ReportsAndDocumentsIcon className="me-3" />
          {/* The 'NEW' Badge/Tag */}
          <span className="custom-nav-new-badge flashing-badge floating-new-badge">
            NEW
          </span>
        </span>
      );
    },
  },

  // {
  //   target: "videos",
  //   name: "Video Resources",
  //   to: "/videos",
  //   active: false,
  //   icon: () => {
  //     return <Icon.CameraVideo size={"23"} className="me-3" />;
  //   },
  // },
];
